import { OUT_SERVICE_URL } from './constants.js';
export const getRegionUrl = (typeForm) => typeForm === 'OUTSERVICE' ? OUT_SERVICE_URL : undefined;
//# sourceMappingURL=getRegionUrl.js.map